import { useBlocker } from "react-router-dom";
import { useEffect, useState } from "react";

export function usePrompt(when: boolean, onBlock: () => void) {
  const [blockerRef, setBlockerRef] = useState<any>(null);

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return when && currentLocation.pathname !== nextLocation.pathname;
  });

  useEffect(() => {
    if (blocker.state === "blocked") {
      setBlockerRef(blocker);
      onBlock(); // 👉 show modal ONLY ONCE
    }
  }, [blocker.state]);

  return {
    blocker: blockerRef,
  };
}